module.exports = __webpack_public_path__ + "img/c08_unitstartechgadawarriorchampion_Normal_ua.b1eb8f27.webp";